import {useEffect, useState} from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'
import {css} from '@emotion/react'
import {isChrome} from '../../../util/userAgent'
import {colors} from '../../../constants'

const translations = {
    en: {
        installNumber: `200,000+`,
    },
    de: {
        installNumber: `200.000+`,
    },
}

const BrowserStoreWidget = ({languageCode = `en`}) => {
    const logo = useStaticQuery(graphql`
        query BrowserStoreWidgetQuery {
            chromeLogo: file(relativePath: {eq: "logoChrome.png"}) {
                childImageSharp {
                    fixed(height: 50, quality: 80) {
                        ...GatsbyImageSharpFixed_noBase64
                    }
                }
            }
            firefoxLogo: file(relativePath: {eq: "logoFirefox.png"}) {
                childImageSharp {
                    fixed(height: 50, quality: 80) {
                        ...GatsbyImageSharpFixed_noBase64
                    }
                }
            }
            starRatingFirefox: file(relativePath: {eq: "starRating5.png"}) {
                childImageSharp {
                    fixed(height: 22, quality: 80) {
                        ...GatsbyImageSharpFixed_noBase64
                    }
                }
            }
            starRatingChrome: file(relativePath: {eq: "starRating4.5.png"}) {
                childImageSharp {
                    fixed(height: 22, quality: 80) {
                        ...GatsbyImageSharpFixed_noBase64
                    }
                }
            }
        }
    `)

    const text = translations[languageCode]

    const [browserLogo, setBrowserLogo] = useState(logo.firefoxLogo.childImageSharp.fixed)
    const [installNumber, setInstallNumber] = useState(text.installNumber)
    const [starRating, setStarRating] = useState(logo.starRatingFirefox.childImageSharp.fixed)

    useEffect(() => {
        if (isChrome()) {
            setBrowserLogo(logo.chromeLogo.childImageSharp.fixed)
            setInstallNumber(text.installNumber)
            setStarRating(logo.starRatingChrome.childImageSharp.fixed)
        }
    }, [logo.chromeLogo.childImageSharp.fixed, logo.starRatingChrome.childImageSharp.fixed, text.installNumber])

    return (
        <div
            className="browser-store-widget"
            css={css`
                display: flex;
                align-items: center;
            `}
        >
            <div
                className="installs"
                css={css`
                    display: flex;
                    align-items: center;
                `}
            >
                <Img
                    fixed={browserLogo}
                    css={css`
                        margin: 0 0.5rem 0 0;
                    `}
                />
                <h3
                    css={css`
                        font-size: 22px;
                        font-weight: 600;
                        span {
                            font-weight: normal;
                        }
                    `}
                >
                    {installNumber} <span>Downloads</span>
                </h3>
            </div>
            <span
                className="divider"
                css={css`
                    height: 32px;
                    width: 1px;
                    background: ${colors.whisperDarkest};
                    margin: 0 10px;
                `}
            />
            <Img fixed={starRating} />
        </div>
    )
}

export default BrowserStoreWidget
